<!--
 * @Description: 
 * @Date: 2023-08-23 17:09:25
-->
<template>
  <div class="qualification-detail">
    <div class="left">
      <template v-if="showImageViewer">
        <div class="viewer-name">
          {{ urlName }}({{ urlIndex + 1 }}/{{ urlList.length }})
        </div>
        <ElImageViewer
          ref="ImageViewerRef"
          class="viewer"
          :urlList="urlList"
          :initialIndex="initialIndex"
          :appendToBody="false"
          :maskClosable="false"
          :onSwitch="handleViewerSwitch"
          @close="handleViewerClose"
        ></ElImageViewer>
      </template>
    </div>
    <div class="right info" v-loading="loading">
      <span class="close" @click="handleCloseClick">
        <i class="el-icon-close"></i>
      </span>
      <div class="content">
        <p class="sub-title">项目资质要求：</p>
        <div class="qualification-texts">
          <div
            class="qualification-text"
            v-for="(item, index) in qualificationTexts"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <div class="audit-opinion">
          {{ showAuditOpinion ? auditOpinion : '' }}
        </div>
        <table class="table" cellspacing="0" cellpadding="0" border="0">
          <colgroup>
            <col width="50%" />
            <col width="50%" />
          </colgroup>
          <tr>
            <th>姓名</th>
            <th>手机号</th>
          </tr>
          <tr>
            <td>{{ fullName }}</td>
            <td>{{ phone }}</td>
          </tr>
        </table>

        <template name="已上传资质">
          <p class="sub-title">执行人已上传，点击查看</p>
          <div
            class="upload-qualification-item"
            :class="{ active: uploadQualificationsActiveIndex === index }"
            v-for="(item, index) in uploadQualifications"
            @click="handleViewPicClick(item, index)"
            :key="index"
          >
            {{ item.certificationName }}
          </div>
        </template>
      </div>
      <div class="btns">
        <el-button
          type="primary"
          @click="handlePassClick"
          :disabled="hideOperateBtn"
        >
          通过
        </el-button>
        <el-button @click="handleNoPassClick" :disabled="hideOperateBtn">
          不通过
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
// props urlList, zIndex，onSwitch,onClose,initialIndex,appendToBody,maskClosable
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { rejectQualifications, passQualifications } from './index';
import { certification } from '@/api/ajax';

export default {
  name: 'qualification-detail',
  components: {
    ElImageViewer: {
      ...ElImageViewer,
      methods: {
        ...ElImageViewer.methods,
        hide() {}
      },
      beforeCreate() {
        Object.defineProperty(this, '_mouseWheelHandler', {
          set: () => {
            return false;
          }
        });
      }
    }
  },
  data() {
    return {
      loading: false,
      nowId: this.id,
      userId: '',
      dealDatas: new Map(),
      initialIndex: 0,
      urlName: '',
      urlList: [],
      urlIndex: 0,
      fullName: '',
      phone: '',
      qualifications: [],
      uploadQualificationsActiveIndex: -1,
      uploadQualifications: [],
      auditOpinion: '',

      status: {
        zbBlackStatus: '', // 2  永久黑名单
        userStatus: '', // 3 已注销
        superviseStatus: '', //3 监管停用
        auditAspStatus: '', //ASP审核状态 1待审核 2审核通过 3审核未通过
        auditOssStatus: '' //OSS审核状态 1未审核 2审核通过 3审核未通过
      }
    };
  },
  props: {
    id: Number,
    defaultParams: Object
  },
  computed: {
    projectId() {
      return this.defaultParams && this.defaultParams.projectId;
    },
    hideOperateBtn() {
      const {
        zbBlackStatus,
        userStatus,
        superviseStatus,
        auditAspStatus,
        auditOssStatus
      } = this.status;
      return (
        zbBlackStatus == 2 ||
        userStatus == 3 ||
        superviseStatus == 3 ||
        [2, 3].includes(+auditAspStatus || '') ||
        [2, 3].includes(+auditOssStatus)
      );
    },
    showAuditOpinion() {
      const { auditAspStatus, auditOssStatus } = this.status;
      return [3].includes(+auditAspStatus) || [3].includes(+auditOssStatus);
    },
    showImageViewer() {
      return this.uploadQualificationsActiveIndex > -1;
    },
    qualificationTexts() {
      return this.qualifications
        .map(texts =>
          Array.isArray(texts)
            ? `${texts.map(text => `【${text}】`).join(' 或 ')}`
            : ''
        )
        .filter(Boolean);
    }
  },
  methods: {
    handleViewerSwitch(index) {
      this.urlIndex = index;
    },
    handleViewerClose() {},
    handleViewPicClick(uploadQualificationItem, index) {
      try {
        this.$refs['ImageViewerRef'].index = 0;
        this.$refs['ImageViewerRef'].transform = {
          scale: 1,
          deg: 0,
          offsetX: 0,
          offsetY: 0,
          enableTransition: false
        };
      } catch (error) {
        console.warn('change image-viewer index err', error);
      }
      this.uploadQualificationsActiveIndex = index;
      this.urlName = uploadQualificationItem.certificationName;
      this.urlList = uploadQualificationItem.urlList;
    },
    handleCloseClick() {
      this._close();
      this._resolve(this.dealDatas);
    },
    async handlePassClick() {
      const { nextId } = await passQualifications(
        [this.userId],
        this.defaultParams || {}
      );
      this.dealDatas.set(this.userId, { type: 'pass' });
      this.status.auditAspStatus = 2;
      this.next(nextId);
    },
    async handleNoPassClick() {
      const _defaultParams = this.defaultParams || {};
      const { nextId } = await rejectQualifications(
        [this.userId],
        _defaultParams,
        { min: _defaultParams.type == 2 ? 0 : 5, max: 150 }
      );
      this.dealDatas.set(this.userId, { type: 'no pass' });
      this.status.auditAspStatus = 3;
      this.next(nextId);
    },
    next(nextId) {
      if (nextId) {
        this.nowId = nextId;
        this.setDetail();
      } else {
        this.handleCloseClick();
      }
    },
    async setDetail() {
      this.loading = true;
      const [
        {
          data: {
            data: {
              userId,
              attachmentList,
              phone,
              fullName,
              auditAspStatus,
              auditOssStatus,
              zbBlackStatus,
              userStatus,
              superviseStatus,
              auditOpinion
            }
          }
        },
        {
          data: { data: certificationList }
        }
      ] = await Promise.all([
        certification.queryCertificationProjectUserDetail({
          cpuId: this.nowId
        }),
        this.qualifications.length > 0
          ? new Promise(r => r({ data: { data: void 0 } }))
          : certification.queryCertificationList({
              projectId: this.projectId
            })
      ]);
      this.auditOpinion = ['审核未通过', auditOpinion]
        .filter(Boolean)
        .join('：');
      this.userId = userId;
      this.fullName = fullName;
      this.phone = phone;
      if (Array.isArray(certificationList)) {
        this.qualifications = certificationList.map(i =>
          i.map(i => i.certificationName)
        );
      }
      this.uploadQualifications = attachmentList;

      // 默认选择第一条
      Array.isArray(attachmentList) &&
        attachmentList.length > 0 &&
        this.handleViewPicClick(this.uploadQualifications[0], 0);

      this.status = {
        auditAspStatus,
        auditOssStatus,
        zbBlackStatus,
        userStatus,
        superviseStatus
      };
      this.loading = false;
    }
  },
  created() {
    this.setDetail();
  }
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeInRight {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
.fadeIn {
  opacity: 0;
  animation: fadeIn 0.3s forwards;
}
.fadeInRight {
  opacity: 0;
  transform: translateX(100%);
  animation: fadeInRight 0.3s forwards;
}

.qualification-detail {
  $--color-primary: #409eff;
  $infoWidth: 450px;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: calc(100% - #{$infoWidth}) $infoWidth;
  .left {
    width: 100%;
    height: 100%;
    position: relative;
    .viewer-name {
      font-size: 16px;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      text-align: center;
      color: #fff;
      padding: 24px 20%;
      z-index: 9999;
      background: rgba(0, 0, 0, 0.6);
    }
    .viewer {
      position: absolute;
      width: 100%;
      height: 100%;
      overflow: hidden;
      @extend .fadeIn;
      ::v-deep {
        .el-image-viewer {
          &__mask {
            display: none;
          }
          &__close {
            display: none;
          }
        }
      }
    }
  }
  .right {
    height: 100%;
    background-color: #fff;
    font-size: 14px;
    $borderColor: #d5d5d5;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    @extend .fadeInRight;
    .close {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 28px;
      line-height: 0;
      cursor: pointer;
      transition: all 0.3s;
      background-color: #fff;
      padding: 8px;
      border-bottom-left-radius: 12px;
      z-index: 2001;
      i {
        color: #666;
      }
      &:hover {
        i {
          opacity: 0.8;
        }
      }
    }
    .content {
      height: 100%;
      overflow: auto;
      padding: 16px;
      padding-bottom: 24px;
      position: relative;
      .sub-title {
        font-size: 14px;
        color: #666;
        margin-bottom: 16px;
        pointer-events: none;
      }
      .qualification-texts {
        padding-bottom: 16px;
        border-bottom: 2px solid #b9b9b9;
        margin-bottom: 20px;
        .qualification-text + .qualification-text {
          margin-top: 12px;
        }
      }
      .audit-opinion {
        margin-bottom: 20px;
        font-size: 14px;
        color: red;
      }
      .table {
        width: 100%;
        text-align: center;
        border: 1px solid $borderColor;
        margin-bottom: 40px;
        th {
          background-color: #e8e8e8;
        }
        th,
        td {
          height: 40px;
          border-right: 1px solid $borderColor;
          border-bottom: 1px solid $borderColor;
          font-size: 14px;
          &:last-child {
            border-right: none;
          }
        }
        tr {
          &:last-child {
            th,
            td {
              border-bottom: none;
            }
          }
        }
      }
      .upload-qualification-item {
        width: 100%;
        min-height: 40px;
        border: 1px solid $borderColor;
        padding: 12px 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        user-select: none;
        position: relative;
        border-radius: 4px;
        & + .upload-qualification-item {
          margin-top: 12px;
        }
        &::before {
          content: '';
          width: 10px;
          height: 10px;
          border-radius: 100%;
          border: 5px solid #fff;
          position: absolute;
          left: 10px;
          top: 50%;
          opacity: 0;
          transform: translateY(-50%) scale(0);
          box-sizing: content-box;
          transition: all 0.6s;
        }
        &.active {
          border-color: $--color-primary;
          background-color: $--color-primary;
          color: #fff;
          pointer-events: none;
          transition: all 0.15s;
          &::before {
            opacity: 1;
            transform: translateY(-50%) scale(1);
          }
        }
      }
    }
    .btns {
      position: relative;
      padding: 16px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      &::before {
        content: '';
        width: 100%;
        height: 1px;
        box-shadow: 0 -1px 2px #919191;
        left: 0;
        top: 0;
        position: absolute;
      }
    }
  }
}
</style>
